var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('h1',{staticClass:"warningTemporary",attrs:{"id":"mainAlert"}},[_c('span',{attrs:{"id":"mainAlertTxt"}},[_vm._v("warning")]),_vm._v(" "),_c('span',{staticClass:"mainAlertTxtclose",on:{"click":function($event){return _vm.notifyErrorForceClose()}}},[_vm._v("\n      X\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7eda5b6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 692
// module chunks = 2